import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Save, MessageCircle, Phone, Mail, MapPin, Clock, Instagram, Facebook, Youtube, Handshake } from "lucide-react";

const GROUPS = [
  {
    title: "WhatsApp del club",
    hint: "Se usa en los botones de consulta de Socios y Tienda de todo el sitio. Solo números, con código de país (ej: 5491122334455).",
    fields: [
      { name: "whatsapp", label: "WhatsApp general", icon: MessageCircle, placeholder: "5491122334455" },
      { name: "whatsapp_sponsors", label: "WhatsApp para auspiciantes", icon: Handshake, placeholder: "5491122334455" },
    ],
  },
  {
    title: "Contacto directo",
    hint: "Datos de contacto que aparecen en el pie de página y en el botón de llamada.",
    fields: [
      { name: "phone_display", label: "Teléfono (visible)", icon: Phone, placeholder: "+54 (011) 4444-5555" },
      { name: "phone", label: "Teléfono (para llamar)", icon: Phone, placeholder: "+541144445555" },
      { name: "email", label: "Email", icon: Mail, placeholder: "info@leonowak.org" },
      { name: "address", label: "Dirección", icon: MapPin, placeholder: "Av. del Club 1976" },
      { name: "hours", label: "Horario de sede", icon: Clock, placeholder: "Lun a Sáb · 9 a 22 h" },
    ],
  },
  {
    title: "Redes sociales",
    hint: "URLs completas de las redes del club.",
    fields: [
      { name: "instagram", label: "Instagram", icon: Instagram, placeholder: "https://instagram.com/…" },
      { name: "facebook", label: "Facebook", icon: Facebook, placeholder: "https://facebook.com/…" },
      { name: "youtube", label: "YouTube", icon: Youtube, placeholder: "https://youtube.com/…" },
    ],
  },
];

export default function AdminContactoTab() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);
  const field = "w-full border border-gray-200 rounded-lg pl-9 pr-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-navy/30";

  const load = useCallback(async () => {
    const { data } = await api.get("/content/footer");
    setData(data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    const fd = new FormData(e.target);
    const body = {};
    GROUPS.forEach((g) => g.fields.forEach((f) => { body[f.name] = fd.get(f.name) || ""; }));
    try {
      const { data: res } = await api.put("/content/footer", body);
      setData(res);
      toast.success("Datos de contacto actualizados");
    } catch { toast.error("No se pudo guardar"); }
    finally { setSaving(false); }
  };

  if (!data) return <div className="py-16 flex justify-center text-navy/40"><Loader2 className="h-6 w-6 animate-spin" /></div>;

  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <form onSubmit={save} className="space-y-5" data-testid="contacto-form">
        {GROUPS.map((g) => (
          <section key={g.title} className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm">
            <h3 className="text-navy font-bold" style={{ fontFamily: "Outfit" }}>{g.title}</h3>
            <p className="mt-1 text-sm text-gray-500">{g.hint}</p>
            <div className="mt-4 grid sm:grid-cols-2 gap-3">
              {g.fields.map((f) => (
                <label key={f.name} className="text-sm">
                  <span className="block text-xs font-semibold text-navy mb-1">{f.label}</span>
                  <div className="relative">
                    <f.icon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gold" />
                    <input name={f.name} defaultValue={data[f.name] || ""} placeholder={f.placeholder} className={field} data-testid={`contacto-${f.name}`} />
                  </div>
                </label>
              ))}
            </div>
          </section>
        ))}
        <button data-testid="contacto-save" disabled={saving} className="inline-flex items-center gap-2 bg-navy text-white font-semibold px-6 py-3 rounded-xl hover:bg-[#16235a] disabled:opacity-50">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Guardar datos de contacto
        </button>
      </form>
    </main>
  );
}
